import React from 'react';
import { Box } from '@wix/design-system';
import { useExistingSiteStoreReadyUiStore } from './existingSiteStoreReadyUiStore';
import { ExistingSiteStoreReadyDetailPanel } from './components/ExistingSiteStoreReadyDetailPanel';
import styles from './ExistingSiteStoreReadyStep.scss';

/** Desktop-only column (see AppLayout). */
export function ExistingSiteStoreReadySide() {
  const selectedBoxId = useExistingSiteStoreReadyUiStore((s) => s.selectedBoxId);

  return (
    <Box direction="vertical" width="100%" height="100%" overflow="hidden">
      <div className={styles.existingSiteStoreReadySideInner}>
        <Box
          direction="vertical"
          align="center"
          verticalAlign="top"
          flex="1"
          minHeight="0"
          overflowY="auto"
          width="100%"
        >
          <ExistingSiteStoreReadyDetailPanel key={selectedBoxId} boxId={selectedBoxId} />
        </Box>
      </div>
    </Box>
  );
}
